import { __awaiter } from "tslib";
import { InterconsultService } from "@/services/models/interconsult/interconsult";
const moduleTableInterconsultAdmission = {
    namespaced: true,
    state: {
        interconsults: [],
        interconsult_id: null,
        loading: false,
    },
    getters: {
        getInterconsults(state) {
            return state.interconsults;
        },
        getInterconsultId(state) {
            return state.interconsult_id;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        setInterconsult(state, interconsults) {
            state.interconsults = interconsults;
        },
        setInterconsultId(state, interconsultId) {
            state.interconsult_id = interconsultId;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
    actions: {
        getInterconsults({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const INTERCONSULT = yield InterconsultService.getById(state.interconsult_id);
                commit("setInterconsult", INTERCONSULT);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleTableInterconsultAdmission;
